import { useMinimalCart } from 'features/cart/hooks/use-minimal-cart';
import { useStoreContext } from 'features/store';

import { selectors, useAppSelector } from 'state/global-state';
import { useOrderContext } from 'state/order';

import { useCheckoutContext } from './use-checkout-context';

export const useCheckoutLoadingState = () => {
  const {
    isSubmittingOrder,
    isBuildingCommitOrderPayload,
    isLoadingPaymentMethods,
    isSavingPaymentMethods,
    isOrderLoading,
    isMenuLoading,
    isSelectingStore,
    isFetchingStore,
    serverOrder,
  } = useCheckoutContext();
  const { store } = useStoreContext();
  const { storeChangeRepriceRequestId } = useOrderContext();
  const { isMinimalCartStoreRepricing } = useMinimalCart();

  // Read the pricing state from Redux (set by price order)
  const isPricingOrderFromCart = useAppSelector(selectors.ordering.selectIsPricingOrder);
  const selectedStoreNumber = store?.number ?? null;
  const serverOrderStoreNumber =
    serverOrder?.cart?.storeDetails?.storeNumber ??
    serverOrder?.cart?.storeId?.toString?.() ??
    null;
  const isStoreChangeRepricePending = Boolean(
    storeChangeRepriceRequestId &&
      selectedStoreNumber &&
      serverOrderStoreNumber &&
      selectedStoreNumber !== serverOrderStoreNumber
  );

  // Combine local order loading state with cart pricing state
  const isOrderPriceLoading =
    isOrderLoading ||
    isPricingOrderFromCart ||
    isMinimalCartStoreRepricing ||
    isStoreChangeRepricePending;

  const isCheckoutInitializing =
    isOrderPriceLoading ||
    isLoadingPaymentMethods ||
    isMenuLoading ||
    isSelectingStore ||
    isFetchingStore;

  const isPlaceOrderLoading =
    isOrderPriceLoading ||
    isSubmittingOrder ||
    isBuildingCommitOrderPayload ||
    isLoadingPaymentMethods;

  return {
    isOrderPriceLoading,
    isSubmittingOrder,
    isBuildingCommitOrderPayload,
    isLoadingPaymentMethods,
    isSavingPaymentMethods,
    isCheckoutLoading: isCheckoutInitializing || isSubmittingOrder || isBuildingCommitOrderPayload,
    isPlaceOrderLoading,
  };
};
